import { render, staticRenderFns } from "./projectfour.vue?vue&type=template&id=a87b9d60&scoped=true&"
import script from "./projectfour.vue?vue&type=script&lang=js&"
export * from "./projectfour.vue?vue&type=script&lang=js&"
import style0 from "./projectfour.vue?vue&type=style&index=0&id=a87b9d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87b9d60",
  null
  
)

export default component.exports